import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./header/component";
import NavigationBar from "./navigation/component";
import AboutUs from "./about-us/component";
import Contact from "./contact/component";
import Samples from "./samples/component";
import LegalNotice from "./legal-notice/component";
import Home from "./home/Home";
import Footer from "./footer/component";

const Main = () => {
  const contentStyle = { backgroundColor: "rgba(194,218,255,24)" };
  const navigationStyle = { backgroundColor: "light" };

  return (
    <div className="container">
      <Header />
      <div style={navigationStyle}>
        <NavigationBar location={useLocation()} />
      </div>

      <div className="container" style={contentStyle}>
        <center>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about_us" element={<AboutUs />} />
            <Route path="/samples" element={<Samples />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal_notice" element={<LegalNotice />} />
          </Routes>
        </center>
      </div>

      <div style={navigationStyle}>
        <Footer />
      </div>
    </div>
  );
};

export default Main;
